module.exports = __webpack_public_path__ + "img/print-slash.400f0de6.svg";